import { render } from "./TermsofServicePage.vue?vue&type=template&id=33182029&scoped=true"
const script = {}

import "./TermsofServicePage.vue?vue&type=style&index=0&id=33182029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33182029"]])

export default __exports__